import gql from "graphql-tag";

export const ACCOUNTING_RUNS = gql`
    query accountingRuns2($filter: AccountingRun2FilterInput) {
        accountingRuns2(filter: $filter) {
            _id
            type
            accountingPeriod
            number
            status
            clientId
            endDate
            clientTAccountChartId
            clientTAccountChart {
                _id
                name
                version
            }
            keepManualJournalEntries
            updateTimestamp
            updateUserInfo {
                _id
                name
            }
        }
    }
`;

export const ACCOUNTING_RUN = gql`
    query accountingRun2($id: GraphQLObjectId!) {
        accountingRuns2(filter: { idIn: [$id] }) {
            _id
            type
            accountingPeriod
            number
            status
            clientId
            client {
                _id
                name
                accountingCurrency
                accountingCompanyType
            }
            endDate
            clientTAccountChartId
            clientTAccountChart {
                _id
                name
                version
                tAccounts {
                    number
                    description
                    group1
                    group2
                    group3
                    group4
                    group5
                }
            }
            updateTimestamp
            updateUserId
            updateUserInfo {
                _id
                name
            }
        }
        me {
            _id
            roles {
                _id
                assets
                clientIds
                permissionType
            }
        }
    }
`;

export const UPSERT_ACCOUNTING_RUN = gql`
    mutation upsertAccountingRun($input: UpsertAccountingRunInput!) {
        upsertAccountingRun(input: $input) {
            _id
            type
            accountingPeriod
            number
            status
            clientId
            client {
                _id
                name
            }
            endDate
            clientTAccountChartId
            clientTAccountChart {
                _id
                name
                version
                locked
            }
            keepManualJournalEntries
            journalEntries {
                _id
                batch
            }
            createUserId
            createTimestamp
            updateTimestamp
            updateUserId
            updateUserInfo {
                _id
                name
            }
        }
    }
`;

export const UPDATE_ACCOUNTING_RUN_STATUS = gql`
    mutation updateAccountingRunStatus2($_id: GraphQLObjectId!, $status: AccountingRunStatusEnum!) {
        updateAccountingRunStatus2(_id: $_id, status: $status)
    }
`;

export const INVENTORY = gql`
    query inventory($clientId: GraphQLObjectId!, $endDate: GraphQLDateString!) {
        inventory(clientId: $clientId, endDate: $endDate) {
            instrumentId
            instrument {
                _id
                name
            }
            initialCost
            quantity
            initialFxRate
            initialPrice
            localAmount
        }
    }
`;

// portfolio side of the reconciliation of an accounting run: positions and cash account balances at the end date, positions at the end
// of the previous period, the create redeem and dividend paid items of the period, and fx rates
export const RECONCILIATION = gql`
    query reconciliation2(
        $clientId: GraphQLObjectId!
        $endDate: GraphQLDateString!
        $previousEndDate: GraphQLDateString!
        $startDate: GraphQLDateString!
        $fxDate: GraphQLSwedenDate!
        $statusIn: [TransactionStatus!]
    ) {
        positions: tradingmanager(
            filterZeroPositions: true
            filter: { clientIds: [$clientId], endDate: $endDate, statusIn: $statusIn }
            lookThrough: false
            groupPositionsBy: ExternalAccountId
        ) {
            instrumentId
            name
            quantity
            currency
            exposure
            instrument {
                _id
                modelType
                productType
            }
        }
        previousPositions: tradingmanager(
            filterZeroPositions: true
            filter: { clientIds: [$clientId], endDate: $previousEndDate, statusIn: $statusIn }
            lookThrough: false
            groupPositionsBy: ExternalAccountId
        ) {
            instrumentId
            exposure
        }
        transactionItems(
            filter: {
                clientIds: [$clientId]
                statusIn: $statusIn
                startDate: $startDate
                endDate: $endDate
                itemTypeIn: [CreateRedeem, CreateRedeemAdjustmentAmount, CreateRedeemAdjustmentShares, DividendPaid]
            }
        ) {
            _id
            type
            amount
            fxRate
            performanceType
        }
        cashLadder(clientIds: [$clientId], endDate: $endDate) {
            instrumentId
            instrument {
                _id
                name
                modelType
                productType
                currency
            }
            dates
            balances
        }
        fxValuations(date: $fxDate) {
            name
            price
        }
    }
`;

// the last active NAV on or before the end date, for the NAV check of a fund
export const RECONCILIATION_NAV = gql`
    query reconciliationNav2($clientId: GraphQLObjectId!, $endDate: GraphQLDateString!) {
        navs(clientId: $clientId, date: $endDate, lastOnly: true) {
            _id
            date
            status
            client {
                accounts {
                    defaultAccount
                    defaultCashInstruments {
                        partyInstrumentId
                    }
                }
            }
            data {
                positions {
                    instrumentId
                    name
                    value
                    quantity
                }
                classes {
                    instrumentId
                    name
                    navPerUnit
                    unitsAfterOrders
                    fxRate
                    navAfterAdjustmentsAfterOrders
                    weight
                }
                transactions {
                    instrumentId
                    currency
                    amount
                    accountingAmount
                    transactionType
                }
            }
        }
    }
`;
